import styled from 'styled-components'
import { colors } from '../../theme'

export const Label = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 6px;

  cursor: pointer;
`

export const Switch = styled.div<{ adm?: boolean }>`
  position: relative;
  width: 45px;
  height: 22px;
  background: ${({ adm }) => (adm ? colors.grey400 : colors.error)};
  border-radius: 32px;
  padding: 4px;
  transition: 300ms all;

  &:before {
    transition: 300ms all;
    content: '';
    position: absolute;
    width: 16px;
    height: 16px;
    border-radius: 35px;
    top: 50%;
    left: 4px;
    background: white;
    transform: translate(0px, -50%);
  }
`

export const SwitchInput = styled.input`
  display: none;

  &:checked + ${Switch} {
    background: ${colors.secondary};

    &:before {
      transform: translate(20px, -50%);
    }
  }

  &:disabled + ${Switch} {
    cursor: not-allowed;
  }
`
